// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer_nav_github":"Footer_footer_nav_github__6hP9s","footer_nav_linkedin":"Footer_footer_nav_linkedin__7+dDM"};